import { render, staticRenderFns } from "./PdpFeedbackTab.vue?vue&type=template&id=9287acfe&scoped=true"
import script from "./PdpFeedbackTab.vue?vue&type=script&lang=js"
export * from "./PdpFeedbackTab.vue?vue&type=script&lang=js"
import style0 from "./PdpFeedbackTab.vue?vue&type=style&index=0&id=9287acfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9287acfe",
  null
  
)

export default component.exports